import { internal, template } from '../../vendor/elix.js';

function InputStateContainerMixin(Base) {

  return class InputStateContainer extends Base {

    get [internal.template]() {

      return template.html`

        <style>
        
          .inputStateContainer {
            display: block;
            position: relative;
          }

        </style>

        <div class="inputStateContainer">
          ${super[internal.template].innerHTML}
        </div>
      `;
    }
  }

}

export default InputStateContainerMixin;
